<div class="right-margin">
  <button class="close-icon" (click)="closeDialog()"><div class="line1"><div class="line2"></div></div></button>
</div>
<div class="body form">
  <h2>Confirm</h2>
  <div>{{confirmMessage}}</div>
  <div>
    <select name="sellerContract" [(ngModel)]="sellerContract">
      <option [ngValue]="null" [disabled]="true">Sales Agreement</option>
      @for (sellerContract of sellerContracts; track sellerContract) {
        <option [ngValue]="sellerContract">{{sellerContract.name}}</option>
      }
    </select>
  </div>
  @if (sellerContract!=null) {
    <div>Hash: {{sellerContract.hash}}</div>
  }
  <div class="block-buttons">
    <button type="button" (click)="confirm()">Finish</button>
  </div>
</div>